import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Container from "../components/Container";
import SectionTitle from "../components/Home/SectionTitle";

export default function PalmSunday() {
  const [content, setContent] = useState({ hero: {}, hymn: {}, reflection: {} });

  useEffect(() => {
    fetch("/data/palm-sunday.json")
      .then((response) => response.json())
      .then(setContent)
      .catch(console.error);
  }, []);

  return (
    <main className="pb-20">
      <section className="pb-8 pt-10">
        <Container>
          <div className="rounded-[32px] bg-[#f3eee5] px-6 py-10 text-right md:px-10 lg:flex lg:items-end lg:justify-between">
            <div className="max-w-3xl">
              <p className="text-sm font-bold text-[#8a7355]">{content.hero.eyebrow}</p>
              <SectionTitle
                title={content.hero.title}
                classes="mt-3 text-[#3e352b]"
              />
              <p className="mt-4 max-w-2xl text-[16px] leading-7 text-[#5d5348]">
                {content.hero.date}
              </p>
            </div>

            <Link
              to={content.hero.backUrl || "/information"}
              className="mt-6 inline-flex rounded-full border border-[#8a7355] px-5 py-3 text-sm font-bold text-[#5d5348] transition-colors hover:bg-[#8a7355] hover:text-white lg:mt-0"
            >
              {content.hero.backLabel}
            </Link>
          </div>
        </Container>
      </section>

      <section>
        <Container>
          <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
            <article className="rounded-[32px] border border-[#eadfce] bg-white p-6 text-right shadow-[0_18px_60px_rgba(76,58,37,0.08)] md:p-8">
              <p className="text-sm font-bold text-[#8a7355]">{content.hymn.eyebrow}</p>
              <h2 className="mt-3 text-2xl font-bold text-[#3e352b]">
                {content.hymn.title}
              </h2>
              <p className="mt-5 text-[17px] leading-9 text-[#4b4034]">
                {content.hymn.body}
              </p>

              <audio controls preload="none" className="mt-6 w-full">
                <source src={content.hymn.audio} type="audio/mpeg" />
                {content.hymn.audioFallback}
              </audio>

              <a
                href={content.hymn.audio}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex rounded-full border border-[#d8ccb8] px-4 py-2 text-sm font-bold text-[#6e5c47] transition-colors hover:bg-[#8a7355] hover:text-white"
              >
                {content.hymn.audioButtonLabel}
              </a>
            </article>

            <article className="rounded-[32px] border border-[#eadfce] bg-white p-6 text-right shadow-[0_18px_60px_rgba(76,58,37,0.08)] md:p-8">
              <p className="text-sm font-bold text-[#8a7355]">{content.reflection.eyebrow}</p>
              <h2 className="mt-3 text-2xl font-bold text-[#3e352b]">
                {content.reflection.title}
              </h2>
              <p className="mt-5 text-[17px] leading-9 text-[#4b4034]">
                {content.reflection.body}
              </p>
            </article>
          </div>
        </Container>
      </section>
    </main>
  );
}
